import { belongsTo } from 'miragejs';

import AttachmentModel from './attachment';

export default AttachmentModel.extend({
  probativeAttachment: belongsTo(),
});
